/** Public careers path used by Promang-connected webshops (Airon pattern). */
export const JOB_OPENING_PUBLIC_PATH = "stillinger";

function originFromConfiguredUrl(raw) {
  const value = String(raw || "").trim();
  if (!value) return null;
  const withScheme = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  try {
    const parsed = new URL(withScheme);
    if (!parsed.hostname) return null;
    return parsed.origin;
  } catch {
    return null;
  }
}

/** Prefer company homepage (`web`), else origin of webshop products URL. Never invent a host. */
export function publicSiteBaseUrl(company) {
  return (
    originFromConfiguredUrl(company?.web) ||
    originFromConfiguredUrl(company?.webshop_products_url) ||
    null
  );
}

export function publicJobOpeningUrl(company, slug) {
  const base = publicSiteBaseUrl(company);
  const safeSlug = String(slug || "").trim();
  if (!base || !safeSlug) return null;
  return `${base}/${JOB_OPENING_PUBLIC_PATH}/${encodeURIComponent(safeSlug)}`;
}
